module.exports = __webpack_public_path__ + "static/media/chart-widget.c39158e7.svg";